// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-mcq-progress {
  margin-left: 40px;
  margin-top: 32px;
  height: 26px;
  text-align: left;
  font-size: 20px;
  letter-spacing: 0;
  color: #212121;
}

.new-mcq-progress-text {
  opacity: 1;
}

.new-mcq-progress-number {
  opacity: 0.37;
}
`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/progressBar/components/progressTitle/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf","sourcesContent":[".new-mcq-progress {\n  margin-left: 40px;\n  margin-top: 32px;\n  height: 26px;\n  text-align: left;\n  font-size: 20px;\n  letter-spacing: 0;\n  color: #212121;\n}\n\n.new-mcq-progress-text {\n  opacity: 1;\n}\n\n.new-mcq-progress-number {\n  opacity: 0.37;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
